export const CameraIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 112 141"
        >
            <g filter="url(#a)" opacity=".07">
                <rect
                    width="72.924"
                    height="11.219"
                    fill="#394855"
                    rx="5.61"
                    transform="matrix(1 0 0 -1 22.622 125)"
                />
            </g>
            <g opacity=".5">
                <rect width="98.168" height="98.168" x="10" fill="#fff" rx="49.084" />
                <rect
                    width="97.668"
                    height="97.668"
                    x="10.25"
                    y=".25"
                    stroke="#394855"
                    strokeOpacity=".5"
                    strokeWidth=".5"
                    rx="48.834"
                />
            </g>
            <path
                fill="#394855"
                d="M37.318 5.078c-11.077 9-18.156 22.73-18.156 38.116 0 27.108 21.976 49.084 49.084 49.084A48.882 48.882 0 0 0 90.012 87.2a48.88 48.88 0 0 1-30.928 10.968C31.976 98.168 10 76.192 10 49.084 10 29.792 21.13 13.1 37.318 5.078Z"
                opacity=".05"
            />
            <rect
                width="88.351"
                height="11.219"
                fill="#fff"
                rx="5.61"
                transform="matrix(1 0 0 -1 14.908 119.203)"
            />
            <rect
                width="87.851"
                height="10.719"
                x=".25"
                y="-.25"
                stroke="#394855"
                strokeOpacity=".3"
                strokeWidth=".5"
                rx="5.36"
                transform="matrix(1 0 0 -1 14.908 118.703)"
            />
            <path
                fill="#394855"
                fillRule="evenodd"
                d="M34.698 119.072a6.102 6.102 0 0 1-5.936-4.868 6.101 6.101 0 0 1 2.454-6.22H20.518a5.61 5.61 0 0 0 0 11.219h34.244l-20.064-.131Z"
                clipRule="evenodd"
                opacity=".05"
            />
            <circle
                cx="59.084"
                cy="49.084"
                r="24.993"
                fill="#394855"
                fillOpacity=".1"
                stroke="#E2E5E7"
                strokeWidth=".5"
            />
            <circle cx="59.084" cy="49.084" r="16.829" fill="#394855" opacity=".5" />
            <circle cx="59.084" cy="49.084" r="14.024" fill="#394855" opacity=".3" />
            <circle
                cx="59.084"
                cy="49.084"
                r="8.866"
                fill="#fff"
                stroke="#394855"
                strokeWidth=".5"
                opacity=".3"
            />
            <circle cx="63.291" cy="45.578" r="1.402" fill="#fff" opacity=".3" />
            <path
                fill="#fff"
                d="M48.566 95.731c0-1.515.87-2.885 2.335-3.273 1.747-.462 4.475-.952 8.183-.952s6.436.49 8.183.952c1.465.388 2.335 1.758 2.335 3.273v12.604H48.566V95.731Z"
            />
            <path
                stroke="#394855"
                strokeOpacity=".3"
                strokeWidth=".5"
                d="M48.816 95.731c0-1.424.814-2.678 2.149-3.03 1.727-.458 4.433-.945 8.119-.945s6.392.487 8.119.944c1.334.353 2.149 1.607 2.149 3.031v12.354H48.816V95.731Z"
            />
            <path
                fill="#394855"
                d="M50.9 92.458c-1.464.388-2.334 1.758-2.334 3.273v12.604h6.591V95.731c0-1.515.87-2.885 2.335-3.273 1.181-.312 2.81-.637 4.888-.815a38.62 38.62 0 0 0-3.296-.137c-3.708 0-6.436.49-8.183.952Z"
                opacity=".05"
            />
            <path
                fill="#FFCB13"
                d="M9.082 40.643a1.286 1.286 0 0 1 2.227 0l8.908 15.428A1.286 1.286 0 0 1 19.102 58H1.288a1.286 1.286 0 0 1-1.114-1.929l8.908-15.428Z"
            />
            <path
                fill="#fff"
                d="M9.643 52.857v-7.714h1.265v7.714H9.643Zm0 2.572v-1.266h1.265v1.266H9.643Z"
            />
            <defs>
                <filter
                    id="a"
                    width="104.924"
                    height="43.219"
                    x="6.622"
                    y="97.781"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_1080_561" stdDeviation="8" />
                </filter>
            </defs>
        </svg>
    );
};
